import { Type } from '@angular/core';
import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';

export class ChartFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    fields: FormFieldModel[];

    appearCondition?: (x: any) => boolean;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        fields: FormFieldModel[],
        appearCondition?: (x: any) => boolean
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.fields = fields;
        this.appearCondition = appearCondition;
    }
}
